import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator"; // 买单吧APP

import Cookie from '../utils/cookie';
import Url from '../utils/url';
import axios from 'axios';
import env from '../env';
var isProd = env.isProduct || env.isPpe;
export default {
  appName: 'maidanba',
  useKNB: false,
  sellChannel: 27,
  theme: 'maoyan',
  hostPrefix: '//show.maoyan.com/qqw',
  hostBetaPrefix: '//show.test.maoyan.com/qqw',
  ajaxUrl: '//show.maoyan.com/maoyansh/myshow/ajax',
  ajaxBetaUrl: '//show.test.maoyan.com/maoyansh/myshow/ajax',
  tokenCookie: 'mdb_show_token',
  linkMap: {
    // 地址跳转映射
    // 首页
    '/myshow/index.html': '/',
    '/movieshow/index.html': '/',
    // 列表相关
    '/movieshowlist/graphic-detail.html': '/graphic',
    '/movieshowlist/show-ticket.html': '/list',
    '/movieshowlist/show-merchant.html': '/merchants',
    '/movieshowlist/show-detail.html': '/detail',
    '/movieshowlist/group.html': '/group',
    '/movieshowlist/search.html': '/search',
    '/movieshowlist/show-shop.html': '/shop',
    // 下单相关
    '/movieshoworder/goods.html': '/tickets',
    '/movieshoworder/pre-order.html': '/confirm',
    '/movieshoworder/area.html': '/partition',
    '/movieshoworder/add-address.html': '/add-addr',
    '/movieshoworder/choose-address.html': '/choose-addr',
    '/movieshoworder/coupon-detail.html': '/coupon-detail',
    '/movieshoworder/seats.html': '/seats',
    '/movieshoworder/coupon.html': '/coupon',
    '/movieshoworder/order-detail.html': '/order-detail',
    '/movieshoworder/order-list.html': '/order-list',
    '/movieshoworder/real-names.html': '/realname',
    '/movieshoworder/seat-area.html': '/seat-area',
    '/movieshoworder/select-seats.html': '/select-seats',
    '/movieshoworder/search-order.html': '/search-order'
  },
  getUserInfo: function getUserInfo() {
    var cookieInfoArr = (Cookie.get('_source__from_') || '').split('||');
    return {
      token: cookieInfoArr[1] || '',
      userId: cookieInfoArr[2] || ''
    };
  },
  getLocation: function getLocation() {
    return {
      lat: Url.getQuery('lat') || Url.getHashQuery('lat'),
      lng: Url.getQuery('lng') || Url.getHashQuery('lng')
    };
  },
  getCity: function getCity() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var lat, lng, preUrl, instance;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              lat = Url.getQuery('lat') || Url.getHashQuery('lat');
              lng = Url.getQuery('lng') || Url.getHashQuery('lng');
              preUrl = isProd ? 'https://show.maoyan.com/maoyansh/myshow/ajax' : 'http://show.test.maoyan.com/maoyansh/myshow/ajax';
              instance = axios.create({
                baseURL: "".concat(preUrl),
                timeout: 15000
              });
              _context.next = 6;
              return instance.get("/city/queryCity?lat=".concat(lat, "&lng=").concat(lng, "&sellchannel=27")).then(function (res) {
                var _res$data = res.data,
                    code = _res$data.code,
                    data = _res$data.data;

                if (code === 200) {
                  Cookie.set('cityid', data.id);
                } else {
                  Cookie.set('cityid', 1);
                }
              }).catch(function (err) {
                console.warn(err);
              });

            case 6:
              return _context.abrupt("return", {
                cityId: Cookie.get('cityid')
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * 登录方法
   */
  login: function login() {
    location.hash = "/mdb/auth".concat(location.hash.replace('#', ''));
  }
};